module.exports = __webpack_public_path__ + "static/img/1-1.ff6e81a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/6/1/1-1.png
// module id = Jqgs
// module chunks = 0